import { Box, Fade } from '@mui/material'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import React from 'react'

import waitingSimba from '../../assets/simba-ai/waiting.png'
import DataLoadingSpinner from '../common/DataLoadingSpinner'
import DataLoadingPulse from '../common/DataLoadingPulse'
import DataLoadingDots from '../common/DataLoadingDots'
import DataLoadingBar from '../common/DataLoadingBar'

const DEFAULT_MESSAGES = [
    "Waiting for Simba AI",
    "Simba is thinking this through...",
    "Good things take a moment, hang tight...",
    "Crunching through your request...",
    "Almost there, putting it all together...",
]

const LOADER_COMPONENTS = {
    dots: DataLoadingDots,
    pulse: DataLoadingPulse,
    spinner: DataLoadingSpinner,
    bar: DataLoadingBar,
}

const DEFAULT_LOADERS = ['dots', 'pulse', 'spinner', 'bar']

/**
 * Full-screen waiting state shown while Simba AI is generating a response.
 * Cycles through `messages` (each paired with a loader from `loaders`) to
 * keep the user's attention during longer waits.
 */
const AIWaitingScreen = ( { messages = DEFAULT_MESSAGES, loaders = DEFAULT_LOADERS, interval = 4000, color = 'primary', children, sx } ) => {

    const [messageIndex, setMessageIndex] = useState( 0 )
    const [messageVisible, setMessageVisible] = useState( true )

    useEffect( () => {
        if ( messages.length < 2 ) return

        const timer = setInterval( () => {
            setMessageVisible( false )
            setTimeout( () => {
                setMessageIndex( prevIndex => ( prevIndex + 1 ) % messages.length )
                setMessageVisible( true )
            }, 300 )
        }, interval )

        return () => clearInterval( timer )
    }, [messages, interval] )

    const Loader = LOADER_COMPONENTS[loaders[messageIndex % loaders.length]] || DataLoadingDots

    return (
        <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" flexDirection="column" gap="10px" sx={sx}>
            <Box component="img" width="25vw" borderRadius="50%" sx={{ aspectRatio: "1 / 1", objectFit: "cover" }} src={waitingSimba} />
            <Fade in={messageVisible} timeout={300}>
                <Box>
                    <Loader color="primary" padding="20px" waitingMessage={messages[messageIndex]} />
                </Box>
            </Fade>
            {children}
        </Box>
    )
}

AIWaitingScreen.propTypes = {
    messages: PropTypes.arrayOf( PropTypes.string ),
    loaders: PropTypes.arrayOf( PropTypes.oneOf( Object.keys( LOADER_COMPONENTS ) ) ),
    interval: PropTypes.number,
    color: PropTypes.string,
    children: PropTypes.node,
    sx: PropTypes.object,
}

export default AIWaitingScreen
